import { createComponentPreviewMapperModel } from '@wix/editor-elements-integrations';
import {
  composeMapper,
  getPanelPreviewStateMap,
  getPartToPreviewStateMap,
} from '@wix/editor-elements-preview-utils';
import type {
  IMenuDefinition,
  IMenuMapperProps,
  IMenuCarmiData,
  IMenuPreviewMapperProps,
  IMenuPreviewWrapperProps,
} from '../Menu.types';
import {
  props as viewerPropsMapper,
  css as viewerCssMapper,
} from './Menu.mapper';
import type { PreviewWrapperProps } from '@wix/editor-elements-types/thunderboltPreview';
import { MenuAnimationName } from '../constants';
import { hamburgerMenuAnimationNameToCssVarsMap } from './utils/MapperUtils';

export const props = composeMapper<
  IMenuMapperProps,
  IMenuDefinition,
  IMenuCarmiData
>()(
  viewerPropsMapper,
  {
    add: ['compPreviewState'],
  },
  (
    resolver,
    dependencies,
    carmiData,
  ): PreviewWrapperProps<IMenuPreviewMapperProps, IMenuPreviewWrapperProps> => {
    const viewerProps = resolver(dependencies, carmiData);
    const { compPreviewState } = dependencies;
    const designPanelPreviewStateMap = getPanelPreviewStateMap(
      compPreviewState,
      'designPanel',
    );
    const layoutPanelPreviewStateMap = getPanelPreviewStateMap(
      compPreviewState,
      'layoutPanel',
    );

    return {
      ...viewerProps,
      previewWrapperProps: {
        compPreviewState,
        designPanelPreviewStateMap,
        layoutPanelPreviewStateMap,
      },
      partToPreviewStateMap: getPartToPreviewStateMap(
        designPanelPreviewStateMap,
      ),
    };
  },
);

export const css = composeMapper()(
  viewerCssMapper,
  {
    add: ['componentViewMode'],
  },
  (resolver, dependencies, carmiData) => {
    const viewerCss = resolver(dependencies, carmiData);
    const { componentViewMode } = dependencies;

    const isEditing = componentViewMode === 'editor';

    return isEditing
      ? {
          ...viewerCss,
          ...hamburgerMenuAnimationNameToCssVarsMap[MenuAnimationName.None],
          '--animation-name': MenuAnimationName.None,
        }
      : viewerCss;
  },
);

export default createComponentPreviewMapperModel({
  props,
  css,
});
